module.exports = {
  imageUrl(url) {
    if (!url) return '' // Safety check
    const urlSplit = url.split('/')
    const fileName = urlSplit[urlSplit.length - 1]
    return `${process.env.VUE_APP_FIRESTORE_URL + fileName + '?alt=media'}`
  },
  imageBackground(url, colors = ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0)']) {
    const urlSplit = url.split('/')
    const fileName = urlSplit[urlSplit.length - 1]
    return `linear-gradient(${colors[0]}, ${colors[1]}), url(${process.env.VUE_APP_FIRESTORE_URL + fileName + '?alt=media'})`
  }
}